import React, { useState, useEffect } from 'react';
import { useSearchParams, useNavigate } from 'react-router-dom';
import { auth } from '../firebaseClient';
import { createUserWithEmailAndPassword } from 'firebase/auth';
import './Auth.css';

function Signup() {
  const [searchParams] = useSearchParams();
  const [info, setInfo] = useState('');
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const navigate = useNavigate();

  // Neu: API_URL
  const API_URL = process.env.REACT_APP_API_URL || 'http://localhost:5001';

  // Wenn bereits eingeloggt, sofort zum Dashboard weiterleiten
  useEffect(() => {
    if (auth.currentUser) {
      navigate('/dashboard');
    }
  }, [navigate]);

  useEffect(() => {
    const cid = searchParams.get('cid');
    const tkn = searchParams.get('token');
    if (!cid || !tkn) {
      setInfo('Ungültiger Link: cid oder token fehlen');
    }
  }, [searchParams]);

  const handleSignup = async (e) => {
    e.preventDefault();
    setInfo('');
    const cid = searchParams.get('cid');
    const tkn = searchParams.get('token');

    if (!cid || !tkn) {
      setInfo('Registrierung nicht möglich, Link-Parameter fehlen.');
      return;
    }

    try {
      const userCred = await createUserWithEmailAndPassword(auth, email, password);
      const user = userCred.user;
      const idToken = await user.getIdToken();
      const resp = await fetch(`${API_URL}/api/linkCustomerIdToEmail`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${idToken}`
        },
        body: JSON.stringify({ customerId: cid, token: tkn })
      });

      if (!resp.ok) {
        const text = await resp.text();
        throw new Error(text);
      }

      setInfo('Registrierung erfolgreich! Du wirst weitergeleitet ...');
      setTimeout(() => {
        navigate('/dashboard');
      }, 2000);
    } catch (error) {
      setInfo('Fehler: ' + error.message);
    }
  };

  return (
    <div className="auth-container">
      <div className="auth-left">
        {/* Optional: Logo / Hintergrund */}
      </div>
      <div className="auth-right">
        <form className="auth-form" onSubmit={handleSignup}>
          <h2>Registrieren</h2>
          {info && <p style={{ color: 'red' }}>{info}</p>}
          <input 
            type="email" 
            placeholder="E-Mail" 
            value={email} 
            onChange={(e) => setEmail(e.target.value)}
            required 
          />
          <input 
            type="password" 
            placeholder="Passwort" 
            value={password} 
            onChange={(e) => setPassword(e.target.value)}
            required 
          />
          <button type="submit">Registrieren</button>
          <div className="switch-auth">
            <p>Schon ein Konto? <a href="/login">Einloggen</a></p>
          </div>
        </form>
      </div>
    </div>
  );
}

export default Signup;
